import CommonPopup from 'components/ui-kit/CommonPopup/index'
import {
  BalanceProfileIcon,
  DepositIcon,
  DepositProfileIcon,
  DownArrow,
  HeaderMenuIconIcon,
  // HeaderSearchIcon,
  LimitIcon,
  LoginSetting,
  LogoutProfileIcon,
  ProfileUserIcon,
  RefferralsProfileIcon,
  RegisterSetting,
  SettingProfileIcon,
  UpArrow,
  VerificationIcon,
  WithdrawalIcon
} from 'components/ui-kit/Icons/svg/index'
import CustomTooltip from 'components/ui-kit/Tooltip/index'
import {
  ANNOUNCEMENTS,
  ROUTE_PATHS,
  SHOW_SIDE_NAV,
  TOOLTIP_VARIANT
} from 'constants/index'
import { getAuthToken } from 'helpers/cookie.helpers'
import { getItem, setItem } from 'helpers/localstorage.helpers'
import { usePreLogin } from 'hooks/usePreLogin'
import { Howler } from 'howler'
import { capitalize } from 'lodash'
import moment from 'moment'
import Login from 'pages/Login'
import OtpPopup from 'pages/Profile/Settings/ChangeEmail/components/OtpPopup/index'
import Wallet from 'pages/Wallet'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useHistory, useLocation, withRouter } from 'react-router-dom'
import { useWindowSize } from 'react-use'
import { useClickOutside } from 'hooks/useClickOutside'
import {
  resetAnnouncements,
  setAnnouncements,
  setNewAnnouncement
} from 'redux-thunk/redux/slices/announcement.slice'
import { setLoginData } from 'redux-thunk/redux/slices/auth.slice'
import { setAccumulatedBonusWagering, setTotalRewards, setUserBonus } from 'redux-thunk/redux/slices/bonus.slice'
import {
  setAffilateCode,
  setShowLoginPopup,
  setShowSignupPopup
} from 'redux-thunk/redux/slices/gameSetting.slice'
import {
  setShowCashierPopup,
  setShowChat,
  // setShowNotification,
  setShowSearchPopup,
  setShowSideNav
  // toggleChat,
  // toggleNotification
} from 'redux-thunk/redux/slices/settings.slice'
import { setUserRank, updateKycData } from 'redux-thunk/redux/slices/user.slice'
import {
  closeNotificationsPanel,
  toggleNotificationsPanel
} from 'games/PredictionMarket/slice-thunk/predictionMarket.slice'
import { getAnnouncements } from 'redux-thunk/thunk/announcement.thunk'
import { userLogout } from 'redux-thunk/thunk/auth.thunk'
import { getAccumulatedBonus, getTotalRewards } from 'redux-thunk/thunk/bonus.thunk'
import {
  getAllCurrency,
  getGameSetting,
  setUpdateAffilateCount
} from 'redux-thunk/thunk/gameSetting'
import { fetchUserInformation, getReferralState, getSignupLimit } from 'redux-thunk/thunk/user.thunk'
import useLiveAnnouncementSocketNameSpace from 'socket-resources/hooks/useAnnouncement'
import useKycSocketNameSpace from 'socket-resources/hooks/useKycSocketNameSpace'
import useRankingSocketNameSpace from 'socket-resources/hooks/useRankingNameSpace'
import { formatPrice } from 'utils/helperFunctions.utils'
import { v4 as uuidv4 } from 'uuid'
import ForgotPasswordPopup from '../Popups/ForgotPasswordPopup/index'
import PasswordUpdation from '../Popups/PasswordUpdatedPopup/index'
import SearchPopup from '../SearchPopup/index'
import CashierPopup from './components/CashierPopup/index'
import ChangeProfilePopup from './components/Chat/components/ChangeProfilePopup/index'
import ReportUserPopup from './components/Chat/components/ReportUser/index'
import TippingPopup from './components/Chat/components/UserDetailsPopup/components/TippingPopup/index'
import UserDetailsPopup from './components/Chat/components/UserDetailsPopup/index'
import WalletSetting from './components/CurrencyDropdown/components/WalletSettings/index'
import WalletSubscription from './components/WalletSubscription/index'
import PredictionMarketHeaderActions from './components/PredictionMarketHeaderActions'
import './header.scss'
// import useWalletSocketNameSpace from 'socket-resources/hooks/useWalletSocketNameSpace'
import useTotalBonusAmountsSocketNameSpace from 'socket-resources/hooks/useTotalBonusAmounts'
import BetaSignupSuccessPopup from '../Popups/BetaSignupSuccessPopup'
import GoldButton from 'components/ui-kit/GoldButton/index'

// import { searchAnimation } from 'assets/animations/index'
import useWageringSocketNameSpace from 'socket-resources/hooks/useWageringNameSpace'
// import LottieIconButton from '../../ui-kit/LottieIconButton'
import { useOnramper } from 'hooks/useOnramper'
// const RewardsMenu = lazy(() => import('./components/RewardsMenu'))

// const RIGHT_SIDE_BAR_SECTIONS = {
//   CHAT_SECTION: 'chatSection',
//   NOTIFICATION_SECTION: 'notificationSection'
// }

const btnBaseStyles =
  'inline-flex items-center justify-center rounded-lg px-6 py-1 text-base font-medium leading-[1.688rem] min-h-11 cursor-pointer whitespace-nowrap shadow-none transition-all duration-300 ease-[ease] [text-wrap:nowrap] focus:shadow-none active:scale-[0.98] active:opacity-80'

const authBtnPrimaryStyles =
  `${btnBaseStyles} ml-4 mr-2 min-w-[120px] border-0 bg-gold-btn text-white hover:bg-gold-btn hover:border-gold-dark max-lg:text-sm max-md:min-h-10 max-md:min-w-[106px] max-md:text-base max-sm:min-h-8 max-sm:min-w-0 max-sm:px-3 max-sm:py-2 max-sm:text-sm max-sm:leading-4`

const authBtnSecondaryStyles =
  `${btnBaseStyles} min-w-[120px] border border-solid border-gold-dark bg-transparent text-gold hover:bg-transparent max-lg:text-sm max-md:min-h-10 max-md:min-w-[106px] max-md:text-base max-sm:min-h-8 max-sm:min-w-0 max-sm:px-3 max-sm:py-2 max-sm:text-sm max-sm:leading-4`

const cashierBtnStyles =
  `${btnBaseStyles} hidden border-0 uppercase bg-gold-btn text-white hover:bg-gold-btn min-[1400px]:block`

const accountBtnStyles =
  'group flex min-h-11 cursor-pointer rounded-lg items-center border-0 bg-[var(--gray-85)] px-2.5 py-1 text-white hover:bg-[var(--gray-85)] max-md:justify-center max-sm:px-2 max-sm:py-1 [&_img]:mr-0 [&_img]:w-[34px] max-sm:[&_img]:h-8 max-sm:[&_img]:w-8 [&_p]:text-xs'

const dropdownItemStyles =
  'flex items-center rounded-[0.625rem] border-0 bg-transparent px-3 py-3 text-sm font-medium leading-4 text-[var(--gray-20)] no-underline hover:bg-[var(--gray-80)] hover:text-white [&.active]:bg-[var(--gray-80)] [&.active]:text-white [&_svg]:mr-2 [&_svg]:h-4 [&_svg]:w-4'

const Header = (props) => {
  const { t } = useTranslation()
  const token = !!getAuthToken()
  const dispatch = useDispatch()
  const history = useHistory()
  const { search } = useLocation()
  const { listenLiveAnnouncementUpdateEvent } = useLiveAnnouncementSocketNameSpace()
  const { listenWageringUpdateEvent } = useWageringSocketNameSpace()
  const { showOnramperWidget } = useOnramper()

  const { listenRankingUpdateEvent } = useRankingSocketNameSpace()
  const { listenKycEvent } = useKycSocketNameSpace()
  const { listenTotalBonusAmountsUpdateEvent } = useTotalBonusAmountsSocketNameSpace()
  const { handleRegister } = usePreLogin()
  const isDemoGame = window?.location?.pathname?.match('/demo')
  const [showVerifyEmailPopup, setShowVerifyEmailPopup] = useState(false)
  const [showBetaThankYouPopup, setShowBetaThankYouPopup] = useState(false)
  const [showResetMailPopup, setShowResetMailPopup] = useState(false)
  const [showWalletSetting, setShowWalletSetting] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isBalanceOpen, setIsBalanceOpen] = useState(false)
  const accountDropdownRef = useRef(null)
  const { width } = useWindowSize()
  const affiliateCode = new URLSearchParams(search).get('affiliateCode')
  const { loginData } = useSelector(state => state.auth)
  const { showLoginPopup, showSignupPopup, demoWallet, gameVolume } = useSelector(
    (state) => state.gameSetting
  )
  const { showWalletPopup } = useSelector((state) => state.wallet)
  const { announcements } = useSelector(
    (state) => state.announcement // newAnnouncements
  )

  const { user } = useSelector((state) => state.user)

  const { totalRewards } = useSelector((state) => state.bonus)
  const notificationsOpen = useSelector((state) => state.predictionMarket?.notifications?.isOpen)

  const accountsMenuOptions = useMemo(
    () => [
      {
        label: t('accountMenuProfile'),
        id: uuidv4(),
        path: ROUTE_PATHS.PROFILE,
        iconComponent: ProfileUserIcon
      },
      {
        label: t('accountMenuTransactions'),
        id: uuidv4(),
        path: ROUTE_PATHS.TRANSACTIONS,
        iconComponent: DepositProfileIcon
      },
      {
        label: t('balance'),
        id: uuidv4(),
        path: ROUTE_PATHS.BALANCE,
        iconComponent: BalanceProfileIcon
      },
      {
        label: t('withdrawals'),
        id: uuidv4(),
        path: ROUTE_PATHS.WITHDRAWALS,
        iconComponent: WithdrawalIcon
      },
      {
        label: t('deposit'),
        id: uuidv4(),
        path: ROUTE_PATHS.DEPOSIT,
        iconComponent: DepositIcon
      },
      // {
      //   label: t('referrals'),
      //   id: uuidv4(),
      //   path: ROUTE_PATHS.REFERRALS,
      //   iconComponent: RefferralsProfileIcon
      // },
      {
        label: t('settings'),
        id: uuidv4(),
        path: ROUTE_PATHS.SETTINGS,
        iconComponent: SettingProfileIcon
      },
      {
        label: t('accountVerification'),
        id: uuidv4(),
        path: ROUTE_PATHS.ACCOUNT_VERIFICATION,
        iconComponent: VerificationIcon
      },
      // {
      //   label: t('limits'),
      //   id: uuidv4(),
      //   path: ROUTE_PATHS.LIMITS,
      //   iconComponent: LimitIcon
      // }
    ],
    []
  )

  const {
    showSideNav,
    showChat,
    showSearchPopup,
    showUserDetailsPopup,
    showTipPopup,
    showCashierPopup,
    showReportUserPopup,
    // showNotification,
    showProfileChangePopup,
    showForgotPasswordPopup,
    showPasswordUpdationPopup,
    showOtpPopup
  } = useSelector((state) => state?.settings)

  const isAnyPopupOpen = Boolean(
    showCashierPopup ||
    isDropdownOpen ||
    isBalanceOpen ||
    notificationsOpen ||
    showWalletSetting
  )

  const closeAllPopups = useCallback(() => {
    setIsDropdownOpen(false)
    setIsBalanceOpen(false)
    setShowWalletSetting(false)
    dispatch(setShowCashierPopup(false))
    dispatch(closeNotificationsPanel())
  }, [dispatch])

  useClickOutside(accountDropdownRef, () => {
    if (isDropdownOpen) setIsDropdownOpen(false)
  })

  const handleToggleAccount = () => {
    const willOpen = !isDropdownOpen
    closeAllPopups()
    if (willOpen) setIsDropdownOpen(true)
  }

  const isMobileOrTablet = width < 1024

  const handleToggleBalance = () => {
    const willOpen = !isBalanceOpen
    // Keep account dropdown open on mobile/tablet so wallet stays mounted inside it
    if (isMobileOrTablet) {
      setShowWalletSetting(false)
      dispatch(setShowCashierPopup(false))
      dispatch(closeNotificationsPanel())
      setIsBalanceOpen(willOpen)
      return
    }
    closeAllPopups()
    if (willOpen) setIsBalanceOpen(true)
  }

  const handleToggleNotifications = () => {
    const willOpen = !notificationsOpen
    closeAllPopups()
    if (willOpen) dispatch(toggleNotificationsPanel())
  }

  const handleOpenCashier = () => {
    closeAllPopups()
    dispatch(setShowCashierPopup(true))
  }

  const handleLinkClick = () => {
    closeAllPopups()
    if (width < 768) {
      showChat && dispatch(setShowChat(false))
    }
  }

  useEffect(() => {
    document.body.classList.toggle('header-popup-open', isAnyPopupOpen)
    return () => document.body.classList.remove('header-popup-open')
  }, [isAnyPopupOpen])

  const handleLiveAnnouncementData = useCallback((e) => {
    dispatch(setAnnouncements(e?.data))
  }, [])

  const handleBonusWageringData = useCallback((e) => {
    dispatch(setAccumulatedBonusWagering(e?.data))
  }, [])

  const handleKycStatusData = useCallback((data) => {
    dispatch(updateKycData(data?.data))
  }, [])

  // const handleRightSideBar = useCallback((section) => {
  //   if (section === RIGHT_SIDE_BAR_SECTIONS.CHAT_SECTION) {
  //     dispatch(toggleChat())
  //     dispatch(setShowNotification(false))
  //   } else if (section === RIGHT_SIDE_BAR_SECTIONS.NOTIFICATION_SECTION) {
  //     dispatch(toggleNotification())
  //     dispatch(setShowChat(false))
  //   }
  // }, [])

  const handleRankingChange = useCallback((e) => {
    dispatch(setUserRank(e?.data))
  }, [])

  const handleTotalAmountsUpdate = useCallback((data) => {
    dispatch(setTotalRewards(data?.data))
  }, [])

  const sidenavExpand = () => {
    setItem(SHOW_SIDE_NAV, !showSideNav)
    dispatch(setShowSideNav(!showSideNav))
    document
      .getElementsByClassName('sidebar-wrap')[0]
      ?.classList.toggle('sidebar-close')
    document
      .getElementsByClassName('page-container')[0]
      ?.classList.toggle('sidebar-close')
    document
      .getElementsByClassName('header')[0]
      ?.classList.toggle('sidebar-close')
  }

  useEffect(() => {
    dispatch(
      getAnnouncements({
        startDate: moment().subtract(7, 'd').format(),
        endDate: moment().format(),
        limit: 50
      })
    )

    dispatch(
      getSignupLimit()
    )

    // TODO remove this when got the permanent solution for resizeObserver error
    window.addEventListener('error', (e) => {
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        )
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        )
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute('style', 'display: none')
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute('style', 'display: none')
        }
      }
    })
  }, [])

  useEffect(() => {
    dispatch(resetAnnouncements())
    if (token) {
      dispatch(fetchUserInformation())
      dispatch(setLoginData({ accessToken: getAuthToken() }))
      dispatch(getTotalRewards())
      dispatch(getAccumulatedBonus())
      dispatch(getReferralState())
    }
  }, [token])

  useEffect(() => {
    if (affiliateCode) {
      dispatch(setAffilateCode(affiliateCode))
      dispatch(setUpdateAffilateCount({ affiliateCode }))
    }
  }, [window.location.pathname, affiliateCode])

  useEffect(() => {
    if (window.location.pathname === ROUTE_PATHS.SIGNUP) {
      dispatch(setShowSignupPopup(true))
    } else if (window.location.pathname === ROUTE_PATHS.LOGIN) {
      dispatch(setShowLoginPopup(true))
    }
    const cleanUpListener = listenLiveAnnouncementUpdateEvent(
      handleLiveAnnouncementData
    )
    return () => {
      cleanUpListener()
    }
  }, [])

  useEffect(() => {
    if (loginData?.accessToken) {
      const wageringListener = listenWageringUpdateEvent(handleBonusWageringData)
      const kycListenerCleaner = listenKycEvent(handleKycStatusData)
      const rankingListenerCleaner = listenRankingUpdateEvent(handleRankingChange)
      const bonusListenerCleaner = listenTotalBonusAmountsUpdateEvent(handleTotalAmountsUpdate)
      return () => {
        wageringListener()
        kycListenerCleaner()
        rankingListenerCleaner()
        bonusListenerCleaner()
      }
    }
  }, [loginData?.accessToken])

  useEffect(() => {
    dispatch(getAllCurrency())
    dispatch(getGameSetting())
  }, [])

  useEffect(() => {
    if (announcements?.rows?.length > 0) {
      setItem(ANNOUNCEMENTS, {
        ...announcements,
        rows: announcements?.rows?.slice(0, 10)
      })
      const newAnnouncement = announcements?.rows
        ?.slice(0, 3)
        ?.filter((ele) => ele?.seen || !ele?.status)
      dispatch(
        setNewAnnouncement(
          announcements?.rows?.length === newAnnouncement?.length
            ? false
            : newAnnouncement?.length < 3
        )
      )
    }
  }, [announcements])

  const handleLogOut = () => {
    dispatch(userLogout({ history }))
    localStorage.clear()
    dispatch(setUserBonus([]))
  }

  useEffect(() => {
    Howler.volume(Number(gameVolume))
  }, [gameVolume])

  // const searchPopupAndChatButtonSection = (
  //   <div className='top-header-right d-none d-xl-flex ms-4'>
  //     <LottieIconButton
  //       active={showSearchPopup}
  //       lottie={searchAnimation}
  //       icon={<HeaderSearchIcon fill='var(--gray-20)' />}
  //       onClick={() => dispatch(setShowSearchPopup(true))}
  //     />
  //     <div className='ms-2' />
  //     {/* <LottieIconButton
  //         active={showChat}
  //         lottie={chatAnimation}
  //         icon={<ChatIcon fill='var(--gray-20)' />}
  //         onClick={() =>
  //           handleRightSideBar(RIGHT_SIDE_BAR_SECTIONS.CHAT_SECTION)}
  //       /> */}
  //     {/* {token && (
  //       <div className='ms-2 position-relative'>
  //         <LottieIconButton
  //           active={showNotification}
  //           lottie={notificationAnimation}
  //           icon={<BellSolidIcon fill='var(--gray-20)' />}
  //           onClick={() =>
  //             handleRightSideBar(RIGHT_SIDE_BAR_SECTIONS.NOTIFICATION_SECTION)}
  //         />
  //         {newAnnouncements && <div className='chat-notification-icon' />}

  //       </div>
  //     )} */}

  //   </div>
  // )

  return (
    <>
      <header
        className={`header fixed left-0 right-0 top-0 z-[11] flex min-h-[55px] items-center [backdrop-filter:blur(3px)] max-sm:min-h-16 ${!showSideNav ? 'sidebar-close' : ''
          } ${(showLoginPopup || showSignupPopup) ? 'sm:z-[1060]' : ''} ${isAnyPopupOpen ? 'header-popup-open !z-[2100]' : ''}`}
      >
        <div className='mx-auto flex w-full max-w-[1400px] items-center justify-between px-4'>
          <div className='flex items-center'>
            <NavLink
              to={ROUTE_PATHS.HOME}
              className='hidden self-center min-[1200px]:block [&_img]:h-[50px]'
            >
              <img src='/assets/images/logo.png' alt='web_logo' />
            </NavLink>
            {/* <CustomTooltip
              variant={TOOLTIP_VARIANT.SIDEBAR_BUTTON}
              message={showSideNav ? t('collapse') : t('expand')}
              showTooltip
            >
              <NavLink
                to='#'
                className='header-toggle-icon hidden min-[1200px]:block'
                onClick={sidenavExpand}
              >
                <HeaderMenuIconIcon />
              </NavLink>
            </CustomTooltip> */}
            <NavLink
              to={ROUTE_PATHS.HOME}
              className='block self-center min-[1200px]:hidden [&_img]:h-[50px]'
              onClick={() => {
                if (width < 768) {
                  dispatch(setShowChat(false))
                }
              }}
            >
              {/* <MobLogoIcon /> */}
              {/* {loginData?.accessToken ? <MobLogoIcon /> : <BrandLogoIcon className='before-login-logo' />} */}
              <img src='/assets/images/logo.png' alt='footer_logo' />
            </NavLink>
            {/* TODO REMOVE IT FROM THE PLACE WHEN FIGMA UPDATED */}
            {/* <div className='dropdown reward-btn header-user-menu d-none d-md-block'>
              <button
                className='btn btn-primary account-btn dropdown-toggle d-none align-items-center'
                type='button'
              >
                <RewardSvgIcon />
                <div className='account-btn-mid-content px-2 d-none d-lg-block'>
                  <p className='m-0 text-uppercase'>{t('rewards')}</p>
                </div>
                <div className='dropdown-icon'>
                  <i className='fa fa-caret-down' aria-hidden='true' />
                </div>
              </button>
              {token && <SuspenseWrapper Component={RewardsMenu} style={{ height: '50px', width: '50px' }} />}
            </div> */}
          </div>
          {token
            ? (
              <>
                {!isMobileOrTablet && (
                  <div className='flex justify-center w-full left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 items-center gap-2'>
                    <WalletSubscription
                      setShowWalletSetting={setShowWalletSetting}
                      sidenavExpand={sidenavExpand}
                      isBalanceOpen={isBalanceOpen}
                      onToggleBalance={handleToggleBalance}
                      onCloseBalance={() => setIsBalanceOpen(false)}
                    />
                    <GoldButton
                      fullWidth={false}
                      className='uppercase h-[44px]'
                      onClick={handleOpenCashier}
                    >
                      {t('cashier')}
                    </GoldButton>
                    <button
                      className='btn btn-primary text-uppercase buy-crypto d-none d-xxl-block'
                      onClick={() => {
                        closeAllPopups()
                        showOnramperWidget()
                      }}
                    >
                      {t('buyCrypto')}
                    </button>
                  </div>
                )}

                <div className='relative z-[21] flex items-center'>
                  <PredictionMarketHeaderActions
                    onToggleNotifications={handleToggleNotifications}
                    onNavigate={closeAllPopups}
                  />
                  <div
                    ref={accountDropdownRef}
                    className={`relative ml-2${isDropdownOpen ? ' show' : ''}`}
                  >
                    <button
                      className={accountBtnStyles}
                      type='button'
                      data-bs-toggle='dropdown'
                      aria-expanded={isDropdownOpen}
                      onClick={handleToggleAccount}
                    >
                      <img
                        src='/assets/images/profile_pic.png'
                        alt='Badge'
                      />
                      <div className='hidden px-2 font-semibold max-md:[&_p]:text-[0.74rem] min-[576px]:block'>
                        <p className='mt-0 mb-1'>{t('account')}</p>
                        <div className='h-1 overflow-hidden bg-[var(--darkGray)]'>
                          <div
                            className='h-full bg-[var(--blue-300)] rounded-[2px]'
                            role='progressbar'
                            aria-valuenow={`${totalRewards?.totalWager}`}
                            aria-valuemin='0'
                            aria-valuemax={`${user?.nextRankingLevels?.[0]?.wagerRequirement || 10000}`}
                            style={{
                              width: `${(+totalRewards?.totalWager / +user?.nextRankingLevels?.[0]?.wagerRequirement) * 100
                                }%`,
                              backgroundColor: user?.userRank?.moreDetails?.color
                            }}
                          />
                        </div>
                      </div>
                      <div className='hidden h-[1.375rem] w-[1.375rem] items-center justify-center rounded-[0.313rem] bg-[var(--gray-80)] text-[var(--gray-20)] min-[576px]:flex group-hover:bg-[var(--gray-80)]'>
                        {!isDropdownOpen
                          ? <DownArrow />
                          : <UpArrow />}
                      </div>
                    </button>
                    <ul
                      className={`${isDropdownOpen ? 'block' : 'hidden'} absolute right-0 z-[1000] m-0 mt-2.5 min-w-[16.3125rem] list-none rounded-xl border-0 bg-[var(--gray-90)] min-h-40 max-h-[calc(100dvh-120px)] p-0 shadow-[rgba(0,0,0,0.25)_0_5px_8px_-4px,rgba(0,0,0,0.18)_0_0_20px_0,rgba(0,0,0,0.35)_0_40px_34px_-16px] ${isMobileOrTablet ? 'overflow-auto' : 'overflow-hidden'}`}
                    >
                      <div className='mb-2.5 bg-[var(--gray-80)] px-5 py-3 rounded-t-xl rounded-b-none'>
                        <h4 className='m-0 text-base font-normal leading-6 text-white'>
                          {t('hello')}, {capitalize(user?.userName) || t('user')}
                        </h4>
                      </div>
                      {isMobileOrTablet && (
                        <li className='mb-2.5 px-2.5 py-3'>
                          <div className='flex flex-col gap-2'>
                            <div className='flex max-lg:flex-col max-lg:[&_button]:w-full flex-wrap lg:items-center gap-2'>
                              <WalletSubscription
                                setShowWalletSetting={setShowWalletSetting}
                                sidenavExpand={sidenavExpand}
                                isBalanceOpen={isBalanceOpen}
                                onToggleBalance={handleToggleBalance}
                                onCloseBalance={() => setIsBalanceOpen(false)}
                              />
                              <GoldButton
                                fullWidth={false}
                                className='uppercase h-[44px]'
                                onClick={handleOpenCashier}
                              >
                                {t('cashier')}
                              </GoldButton>
                            </div>
                            <button
                              type='button'
                              className={`${btnBaseStyles} w-full border-0 bg-gold-btn text-white uppercase`}
                              onClick={() => {
                                closeAllPopups()
                                showOnramperWidget()
                              }}
                            >
                              {t('buyCrypto')}
                            </button>
                          </div>
                        </li>
                      )}
                      {accountsMenuOptions.map((item) => (
                        <li key={item.id} className='my-[0.313rem] px-2.5'>
                          <NavLink to={item.path} className={dropdownItemStyles} onClick={handleLinkClick}>
                            <item.iconComponent /> {item.label}
                          </NavLink>
                        </li>
                      ))}
                      <li className='my-[0.313rem] px-2.5'>
                        <NavLink
                          to='#'
                          className={dropdownItemStyles}
                          activeClassName='bg-[var(--gray-80)] text-white'
                          onClick={() => {
                            handleLogOut()
                            closeAllPopups()
                          }}
                        >
                          <LogoutProfileIcon /> {t('accountMenuLogout')}
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                  {/* Chat and Games popup */}
                  {/* {searchPopupAndChatButtonSection} */}
                  {/* {(showChat || showNotification) && <RightSidebar />} */}
                </div>
                <div className='relative z-[21] hidden'>
                  {isDemoGame && (
                    <button className={`${btnBaseStyles} mr-2 bg-gold-btn text-white`}>
                      {t('demoWallet')}: {formatPrice(Number(demoWallet), false, 3)}
                    </button>
                  )}
                </div>
              </>
              )
            : (
              <div className='relative z-[21] flex items-center'>
                {/* <div className='header-social-links d-none d-md-flex align-items-center'>
                  <a
                    href=''
                    onClick={(e) => {
                      e.preventDefault()
                      openInfoToaster({ message: 'Coming Soon!' })
                    }}
                  >
                    <TwitchIconIcon fill='var(--gray-20)' />
                  </a>
                  <a
                    href=''
                    onClick={(e) => {
                      e.preventDefault()
                      openInfoToaster({ message: 'Coming Soon!' })
                    }}
                  >
                    <TelegramIcon fill='var(--gray-20)' />
                  </a>
                  <a
                    href=''
                    onClick={(e) => {
                      e.preventDefault()
                      openInfoToaster({ message: 'Coming Soon!' })
                    }}
                  >
                    <TwitterChatIcon fill='var(--gray-20)' />
                  </a>
                </div> */}

                {isDemoGame && (
                  <button className={`${btnBaseStyles} mr-2 border-2 border-solid border-transparent bg-gold-btn text-white`}>
                    {t('demoWallet')}: {formatPrice(Number(demoWallet), false, 3)}
                  </button>
                )}
                <PredictionMarketHeaderActions
                  onToggleNotifications={handleToggleNotifications}
                  onNavigate={closeAllPopups}
                />
                <GoldButton
                  fullWidth={false}
                  className='ml-4 mr-2 min-w-[120px] max-lg:text-sm max-md:min-h-10 max-md:min-w-[106px] max-md:text-base max-sm:min-h-8 max-sm:min-w-0 max-sm:px-3 max-sm:py-2 max-sm:text-sm max-sm:leading-4 h-[44px]'
                  onClick={() => handleRegister({ showLoginPopup: true })}
                >
                  <LoginSetting />{t('login')}
                </GoldButton>
                <button
                  className={authBtnSecondaryStyles}
                  onClick={handleRegister}
                >
                  <RegisterSetting />{t('signupTitle')}
                </button>
                {/* Chat and Games popup */}
                {/* {searchPopupAndChatButtonSection}
                {(showChat || showNotification) && <RightSidebar />} */}
              </div>
              )}
        </div>
      </header>

      {isAnyPopupOpen && !showCashierPopup && !showWalletSetting && (
        <div
          className='fixed inset-0 z-[2000] bg-black/50'
          onMouseDown={(event) => {
            event.preventDefault()
            closeAllPopups()
          }}
          aria-hidden='true'
        />
      )}

      {/* {showVerifyEmailPopup && (
        <VerifyEmailPopup handleClose={setShowVerifyEmailPopup} />
      )} */}

      {showBetaThankYouPopup && (
        <BetaSignupSuccessPopup handleClose={setShowBetaThankYouPopup} />
      )}

      {(showSignupPopup || showLoginPopup) && (
        <Login
          showSignupPopup={showSignupPopup}
          setShowVerifyEmailPopup={setShowVerifyEmailPopup}
          setShowBetaThankYouPopup={setShowBetaThankYouPopup}
        />
      )}
      {showResetMailPopup && (
        <CommonPopup
          modalCloseHandler={() => {
            setShowResetMailPopup(false)
          }}
        >
          <div className='flex justify-center py-4 text-center'>
            <h4>{t('signinResetMailSentSuccessContent')}</h4>
          </div>
        </CommonPopup>
      )}
      {showWalletPopup && <Wallet />}
      {showSearchPopup && (
        <SearchPopup setShowSearchPopup={setShowSearchPopup} />
      )}
      {showUserDetailsPopup && <UserDetailsPopup />}
      {showProfileChangePopup && <ChangeProfilePopup />}
      {showTipPopup && <TippingPopup />}
      {showCashierPopup && <CashierPopup />}
      {showReportUserPopup && <ReportUserPopup />}
      {showWalletSetting && (
        <WalletSetting onClose={() => setShowWalletSetting(false)} />
      )}
      {showForgotPasswordPopup && <ForgotPasswordPopup />}
      {showPasswordUpdationPopup && <PasswordUpdation />}
      {showOtpPopup && <OtpPopup />}
    </>
  )
}

export default React.memo(withRouter(Header))
